//INDEX.JS
//Root file of the app

//external modules
import { Root, createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import "@/translate/i18n"
import "@/style/components.css"
import "@/style/index.css"
import "@/style/routes.css"
import "@/style/widgets.css"
import "animate.css"
import "react-toastify/dist/ReactToastify.css"
import "react-confirm-alert/src/react-confirm-alert.css"
import App from "./App"
import * as serviceWorker from "@/serviceWorker"
import reportWebVitals from "@/reportWebVitals"

//Internal modules
import { persistor, store } from "./core/root-reducer"
import { initReducers } from "./core/init-reducers"

const root: Root = createRoot(document.getElementById("root") as HTMLElement)

//Init DOM
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor} onBeforeLift={initReducers}>
      <App />
    </PersistGate>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({})

export { store } from "./core/root-reducer"
